import { render, staticRenderFns } from "./DeleteBillingAdjustment.vue?vue&type=template&id=81a83be2"
import script from "./DeleteBillingAdjustment.vue?vue&type=script&lang=js"
export * from "./DeleteBillingAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports